import { render } from "./AdminLayout.vue?vue&type=template&id=10131946&ts=true"
import script from "./AdminLayout.vue?vue&type=script&lang=ts"
export * from "./AdminLayout.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__